import { render, staticRenderFns } from "./Publicities.vue?vue&type=template&id=240ab04e"
import script from "./Publicities.vue?vue&type=script&lang=js"
export * from "./Publicities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports